"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizes = void 0;
var fontSizes = {
  bodyXs: '10px',
  caption: '12px',
  bodySm: '14px',
  body: '16px',
  sm: '20px',
  medium: '24px',
  lg: '34px',
  xlg: '44px'
};
exports.fontSizes = fontSizes;